<template>
  <div class="settings-patient-portal-container m-4 p-2">
    <div
      class="d-flex flex-row justify-content-between align-items-center mb-3"
    >
      <h5 class="mb-0">Organization</h5>
    </div>

    <b-row>
      <b-col cols="3">
        <b-form-group label="Logo">
          <square-image-cropper
            :image="fileChoosed"
            v-model="cropImage"
            @cropped="saveCroppedImage"
          />
          <div class="d-flex align-items-left mb-2">
            <div
              class="picture-preview mr-2"
              style="width: 220px; height: 130px;"
            >
              <img
                :src="
                  organizationLogo
                    ? organizationLogo
                    : require(`../../assets/avatar-example.png`)
                "
              />
            </div>
            <b-form-group
              :state="formErrors.logo.length == 0 ? null : false"
              :invalid-feedback="formErrors.logo.join(', ')"
              class="d-flex flex-column justify-content-start"
            >
              <input
                ref="fileUpload"
                @change="cropFile"
                type="file"
                accept="image/*"
                hidden
              />
              <label
                class="mb-0 ml-2 text-primary fileUploadLb custom-label"
                @click="chooseFile()"
                ><i class="fa fa-upload m-1"></i>Choose file</label
              >
              <label
                v-if="organizationLogo"
                class="m-2 text-red choose-picture custom-label"
                @click="removePicture()"
                ><i class="fa fa-trash m-1"></i> Remove Picture</label
              >
            </b-form-group>
          </div>
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <b-form-group label="Name">
          <b-form-input
            v-model="organizationName"
            maxLength="50"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="3">
        <b-form-group label="Address Line 1">
          <b-form-input v-model="addressLine1" maxLength="50"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <b-form-group label="Address Line 2">
          <b-form-input v-model="addressLine2" maxLength="50"></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="3">
        <b-form-group label="City">
          <b-form-input v-model="city" maxLength="50"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <b-form-group label="State">
          <v-select v-model="state" trim :options="states"></v-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="3">
        <b-form-group label="Zip Code">
          <b-form-input v-model="zipCode" maxLength="50"></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-button variant="primary" @click="updateData()">
      Save
    </b-button>
  </div>
</template>

<script>
import systemSettingServer from "../../server/systemSetting";
import SquareImageCropper from "../controls/SquareImageCropper.vue";
import { mapActions, mapState } from "vuex";

export default {
  name: "Organization",
  components: {
    SquareImageCropper
  },
  data() {
    return {
      fileChoosed: null,
      cropImage: false,
      organizationLogo: null,
      organizationName: null,
      addressLine1: null,
      addressLine2: null,
      city: null,
      state: null,
      zipCode: null,
      formErrors: {
        name: [],
        logo: []
      }
    };
  },
  async mounted() {
    this.getData();
    this.fetchStates();
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess", "showError"]),
    ...mapActions("client", ["fetchStates"]),
    async getData() {
      const response = await systemSettingServer.get();
      this.organizationName = response.organizationName;
      this.organizationLogo = response.organizationLogo;
      this.addressLine1 = response.organizationAddressLine1;
      this.addressLine2 = response.organizationAddressLine2;
      this.city = response.organizationCity;
      this.state = this.states.find(
        s => s.value == response.organizationState
      )?.label;
      this.zipCode = response.organizationZipCode;
    },
    async updateData() {
      const data = {
        organizationName: this.organizationName,
        organizationLogo: this.organizationLogo,
        organizationAddressLine1: this.addressLine1,
        organizationAddressLine2: this.addressLine2,
        organizationCity: this.city,
        organizationState: this.state?.value,
        organizationZipCode: this.zipCode
      };
      await systemSettingServer
        .update(data)
        .then(() => {
          this.showAlertSuccess();
        })
        .catch(error => {
          this.showError({
            message: error.response.data
          });
        });
    },
    saveCroppedImage(croppedBase64) {
      this.organizationLogo = croppedBase64;
    },
    chooseFile() {
      this.$refs.fileUpload.click();
      this.$refs.fileUpload.value = null;
    },
    async removePicture() {
      this.$dialog
        .confirm(
          {
            title: "Are you sure you want to delete this picture?"
          },
          {
            view: "confirm-delete"
          }
        )
        .then(() => {
          this.organizationLogo = null;
          this.fileChoosed = null;
        });
    },
    validateCropFile(file) {
      let withoutErrors = true;

      const fileSize = (file.size / 1024 / 1024).toFixed(4);

      this.avatarErrors = [];
      if (fileSize > 20) {
        this.avatarErrors.push("Image max size 20 mb");
        withoutErrors = false;
      }

      if (!file.type.includes("image/")) {
        this.avatarErrors.push("Only image file supported");
        withoutErrors = false;
      }

      return withoutErrors;
    },
    cropFile() {
      const file = this.$refs.fileUpload.files[0];
      const result = this.validateCropFile(file);
      if (result) {
        this.fileChoosed = file;
        this.cropImage = true;
      }
    }
  },
  computed: {
    ...mapState("layout", {
      selectedLocationObj: state => state.selectedLocationObj
    }),
    ...mapState("client", {
      states: state =>
        state.states.map(s => ({
          label: s.name,
          value: s.id,
          data: s
        }))
    })
  }
};
</script>
<style scoped>
.custom-label {
  cursor: pointer;
  margin-left: 30px;
}
</style>
